import React from "react";
import { Typography, Popover, Space } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

import { capitalizeFirstLetter } from "../utils/string";

const { Text, Paragraph } = Typography;

const TextWithLabel = ({
  label,
  text,
  icon,
  expandable = false,
  popover = false,
  popoverTitle = null,
  popoverContent = null,
  dataTMId,
  rowsNo = 2,
  isCapitalizeFirstLetter = true
}) => (
  <div style={{ paddingTop: 6 }}>
    <Space>
      <Text style={{ color: "#9B9B9B", whiteSpace: "nowrap" }}>{label}</Text>
      {popover && (
        <Popover title={popoverTitle} content={popoverContent} trigger="click">
          <QuestionCircleOutlined />
        </Popover>
      )}
    </Space>
    {(icon || text) && (
      <div style={{ display: "flex", paddingTop: 10 }}>
        {icon && <div style={{ display: "flex", alignItems: "center", marginBottom: "1em" }}>{icon}</div>}
        {text && (
          <Paragraph
            style={{ paddingLeft: icon ? 5 : 0 }}
            ellipsis={{ rows: rowsNo, expandable: expandable, symbol: "more" }}
            data-tm-id={dataTMId}
          >
            {isCapitalizeFirstLetter ? capitalizeFirstLetter(text) : text}
          </Paragraph>
        )}
      </div>
    )}
  </div>
);

export { TextWithLabel };
